<script setup lang="ts">
import type { IconSize } from '~/utils/icon'
import type { ClassValue } from '~/utils/types'
import { faShare } from '@fortawesome/pro-solid-svg-icons'

const props = defineProps<{
  title: string
  linkClass?: ClassValue
  iconSize?: IconSize
}>()

const siteConfig = useSiteConfig()

const route = useRoute()

const shareData = computed(() => ({
  title: props.title,
  url: siteConfig.url + route.path,
}))

const canShare = computed(
  () =>
    import.meta.client
      && navigator
      && !!navigator.share
      && !!navigator.canShare
      && navigator.canShare(shareData.value),
)

async function share() {
  if (canShare.value) {
    try {
      await navigator.share(shareData.value)
    }
    catch {
      // Do nothing
    }
  }
}
</script>

<template>
  <div class="flex items-center">
    <slot />

    <SocialLink
      provider="facebook"
      :href="`https://www.facebook.com/sharer/sharer.php?u=${shareData.url}`"
      label="Del på Facebook"
      :class="linkClass"
      :size="iconSize"
    />
    <SocialLink
      provider="linkedin"
      :href="`https://www.linkedin.com/cws/share?url=${shareData.url}`"
      label="Del på LinkedIn"
      :class="linkClass"
      :size="iconSize"
    />

    <ClientOnly>
      <button v-if="canShare" aria-label="Del" :class="linkClass" class="flex items-center p-[0.35rem] hover:contrast-75" @click="share">
        <Icon :size="iconSize" :icon="faShare" />
      </button>
    </ClientOnly>
  </div>
</template>
